module.exports = __webpack_public_path__ + "static/media/sre-rejected.6a0da935.svg";